'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { getTrackRecommendationsUrl } from '../../../utils/RoutingUtils';
import BasicInterstitial from '../BasicInterstitial';

const TrackCompleteInterstitial = ({
  toRecommendations,
  trackId
}) => /*#__PURE__*/_jsx(BasicInterstitial, {
  buttonI18n: `learningCenter.tracks.interstitials.${toRecommendations ? 'next' : 'backToTracks'}`,
  buttonLink: toRecommendations ? getTrackRecommendationsUrl(trackId) : '/',
  buttonUse: toRecommendations ? 'secondary' : 'primary',
  headingI18n: "learningCenter.tracks.interstitials.trackComplete",
  illustrationName: "success",
  subheadingI18n: "learningCenter.tracks.interstitials.trackCompleteSubheading",
  use: "success"
});

TrackCompleteInterstitial.propTypes = {
  toRecommendations: PropTypes.bool,
  trackId: (props, propName, componentName) => props.toRecommendations && !['number', 'string'].includes(typeof props[propName]) && new Error(`${propName} prop in ${componentName} must be set when toRecommendations is set to \`true\``)
};
export default TrackCompleteInterstitial;